import { Badges } from "../../AbstractElements";
import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { MoreVertical } from "react-feather";
import { Link } from "react-router-dom";
import { showWarningAlert } from "../../utils/showWarningAlert";
import { useTranslation } from "react-i18next";
import { SMSColumnType, UserListTableDataColumnType } from "../../types/users/UserTypes";


const ActionBadge = ({ status }: { status: string }) => (
  <Badges
    color="transparent"
    className={`badge-light-${
      status === "StandBy"
        ? "danger"
        
        : "success"
    }`}
  >
    {status}
  </Badges>
);

const PaymentListTableAction: React.FC<{ row: SMSColumnType }> = ({
    row,
  }) => {
     
    const { t } = useTranslation();
    const handleActive = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to Active ${row.gateway_name}?`,
        confirmButtonText: t("Confirm"),
        onConfirm: () => {
          // Block logic here
        },
      });
    };
  
    const handleInactive = () => {
      showWarningAlert({
        title: t("Are you sure?"),
        text: `Do you want to InActive ${row.gateway_name}?`,
        confirmButtonText: t("Confirm"),
        onConfirm: () => {
          // Unblock logic here
        },
      });
    };
  
    return (
      <UncontrolledDropdown>
        <DropdownToggle  tag="span" className="cursor-pointer">
          <MoreVertical size={18} />
        </DropdownToggle>
        <DropdownMenu>
          <Link to={`${process.env.PUBLIC_URL}/mastersettings/paymentgateway/view/${row.payment_gateway_id}`}>
            <DropdownItem >{t("View")}</DropdownItem>
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/mastersettings/paymentgateway/edit/${row.payment_gateway_id}`}>
       
       <DropdownItem >{t("Edit")}</DropdownItem>
     </Link>
     {row.status === "StandBy" && <DropdownItem onClick={handleActive}>{t("Default")}</DropdownItem>}
     {row.status === "Default" && <DropdownItem onClick={handleInactive}>{t("StandBy")}</DropdownItem>}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  };
  


export const PaymentGatewayColumns = (t: TFunction): TableColumn<any>[] => [
    {
        name: t("Sl.No"),
        selector: (row) => row.payment_gateway_id,
        sortable: true,
        width: "100px", // Short, fixed width for an ID
        center: true,
      },
      {
        name: t("GatewayName"),
        selector: (row) => row.gateway_name,
        sortable: true,
        minWidth: "150px", // Has a minimum width
        grow: 2, // Will take up 2x the available space compared to a column with grow: 1
        wrap: true,
      },
      {
        name: t("GatewayURL"),
        selector: (row) => row.dashboard_url,
        sortable: true,
        minWidth: "250px",
        grow: 3, // Give this more space as URLs can be long
        cell: (row) => ( // Making the URL a clickable link is good UX
          <a href={row.dashboard_url} target="_blank" rel="noopener noreferrer">
            {row.dashboard_url}
          </a>
        ),
      },
      {
        name: t("Type"),
        selector: (row) => row.type,
        sortable: true,
        minWidth: '180px',
        grow: 2,
        wrap: true,
      },
      {
        name: t("Method"),
        selector: (row) => row.Method,
        sortable: true,
        width: "140px", // Fixed width, as it's just a badge
        center: true,
        cell: (row) => ( // Highlighting the method with a badge
          <Badge
            color={row.Method.toLowerCase() === 'live' ? 'success' : 'warning'}
            pill
            className="text-white"
          >
            {row.Method}
          </Badge>
        ),
      },
      {
        name: t("Status"),
        cell: (row) => <ActionBadge status={row.status} />,
        sortable: true,
        width: "120px", // Fixed width for a status badge
        center: true,
      },
      {
        name: t("Action"),
        cell: (row) => <PaymentListTableAction row={row} />,
        sortable: false, 
        width: "150px", 
        center: true,
      },
    
];


